import React from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale/pt-BR';

interface IDateOutput {
  dateStr?: any;
  patternStr?: string;
}

const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

const zonedDate = (dateStr: string) => {
  return toZonedTime(parseISO(dateStr), timeZone);
};

const DateOutput = (props: IDateOutput) => {
  const { dateStr, patternStr } = props;

  if (!dateStr) return <></>;

  const pattern = patternStr || 'dd/MM/yyyy HH:mm';

  const formattedDate = format(zonedDate(dateStr), pattern, { locale: ptBR });

  return <>{formattedDate}</>;
};

export const DateOutputStr = (dateStr?: string, patternStr?: string) => {
  if (!dateStr) return '';
  const pattern = patternStr || 'dd/MM/yyyy HH:mm';
  return format(zonedDate(dateStr), pattern, { locale: ptBR });
};

export const DateStringPipefy = (dateStr: string, patternStr?: string) => {
  if (!dateStr) return '';
  const pattern = patternStr || "yyyy-MM-dd";
  let date = '';

  if (isValid(new Date(dateStr))) {
    date = format(zonedDate(dateStr), pattern, { locale: ptBR });
  } else {
    const dateSplit = dateStr?.split('/');
    if (dateSplit && dateSplit.length === 3) {
      const dateFormatted = new Date(`${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`);
      const zonedDateFormatted = toZonedTime(dateFormatted, timeZone);
      date = format(zonedDateFormatted, pattern, { locale: ptBR });
    }
  }

  return date;
};

export const DateStringCustomPipefy = (dateStr: string, patternStr?: string) => {
  if (!dateStr) return '';
  const pattern = patternStr || "yyyy-MM-dd";
  let date = '';

  if (isValid(new Date(dateStr)) && !dateStr.includes('/')) {
    date = format(zonedDate(dateStr), pattern, { locale: ptBR });
  } else {
    const dateSplit = dateStr?.split('/');
    if (dateSplit && dateSplit.length === 3) {
      const dateFormatted = new Date(`${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`);
      const zonedDateFormatted = toZonedTime(dateFormatted, timeZone);
      date = format(zonedDateFormatted, pattern, { locale: ptBR });
    }
  }

  return date;
};


export const DateOutputStrISO = (dateStr: Date) => {
  if (!dateStr) return '';

  return dateStr.toISOString();
};

export const FormatDateString = (dateStr: string) => {
  if (!dateStr) return '';

  if (dateStr?.includes("-")) {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }
  else if (dateStr.includes("/")) {
    return dateStr;
  }

  return '';
};

export default DateOutput;
